export const validFormats = ['Number', 'Percentage', 'Currency'];

export const formValidationSchema = {
  name: 'custom column form schema',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      required: true,
      maxLength: 100,
    },
    description: {
      type: 'string',
      required: false,
      maxLength: 255,
    },
    columnFormat: {
      type: 'string',
      enum: validFormats,
    },
  },
};
